// Cómo se muestra un monto en pesos en toda la web: con separador de miles y con centavos solo si los tiene («$1,500», «$1,350.50»),
// igual que la app. Acepta el número o el texto que guarda el servidor («1500»); lo que no es un número sale como $0.
export const dinero = (monto) => {
  const n = Math.round((Number(monto) || 0) * 100) / 100;
  const cifra = Math.abs(n).toLocaleString('es-MX', Number.isInteger(n) ? {} : { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return `${n < 0 ? '-' : ''}$${cifra}`;
};
